import { Box } from "@/components/layout/flexbox";
import { Timeline, TimelineItem } from "@/components/pieces/Timeline";
import { getUser } from "@/components/session/JwtTokenManager";
import { CARD_CLASSES } from "@/css/constants";
import { FullReview } from "@/types/meetings";
import { ensureNonNullArray } from "@/utils/array";

import { FinalCheck, ReviewRound } from "./ReviewTimeline";

export function ReviewSidebar({ review }: { review: FullReview }) {
  const { numRounds = 0, coach } = review;
  const rounds = ensureNonNullArray(review.rounds);
  const isCoach = getUser()?.id === coach?.id;
  const roundsLength = rounds.length;

  const reviewRounds = ensureNonNullArray(
    Array(numRounds)
      .fill(null)
      .map((_, i) => (roundsLength >= i + 1 ? rounds?.[i] : null)),
  );

  return (
    <Box
      backgroundColor="#FFF"
      className={CARD_CLASSES}
      p={[3, 3, 24]}
      mb={[24, 24, 24, 0]}
    >
      <Timeline>
        <TimelineItem intent="success">
          <Box fontWeight={600}>Review Booked</Box>
        </TimelineItem>
        {reviewRounds.map((reviewRound, i) => (
          <ReviewRound
            key={i}
            review={review}
            reviewRound={reviewRound}
            roundNum={i + 1}
            rounds={rounds}
            isCoach={isCoach}
          />
        ))}
        <FinalCheck review={review} isCoach={isCoach} />
      </Timeline>
    </Box>
  );
}
